import { useMemo } from "react";
import { useStore } from "react-redux";
import { formatCurrency, formatNumber } from "../../utils/functions";

const SortenBezeichnung = (props) => {
  const { kennziffer, betrag, iso } = props || {};
  const { currenciesStorage } = useStore().getState();

  const item = useMemo(() => {
    return currenciesStorage.getItems().find(m => Number(m.kennziffer) === Number(kennziffer)) || {};
  }, [kennziffer, currenciesStorage]);
  const currency = String(iso).length === 3 ? iso : item.iso;
  if (!currency || String(currency).length !== 3) return formatNumber(betrag);
  return formatCurrency(betrag, currency);
};

export default SortenBezeichnung;
